import React from "react";
import { TableCell, TableRow } from "@mui/material";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import styled from "styled-components";

const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

const DesignationsEditable = ({
  k, row, editFormData,
  handleCancelClick, page,
  rowsPerPage, onChangeEditDesgn,
  SubmitButton, isUpdating
}) => {
  return (
    <TableRow key={k} name={row.Category}>
      <TableCell component="th" scope="row">
        {page * rowsPerPage + k + 1}
      </TableCell>

      <TableCell align="left">
        <TextField
          id="outlined-basic"
          size="small"
          type="text"
          name="name"
          onChange={(event) => onChangeEditDesgn(event)}
          label="Designation"
          value={editFormData?.name || ""}
          variant="outlined"
          sx={{ backgroundColor: "white", width: 200, height: 40 }}
        />
      </TableCell>

      <TableCell align="left">
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          size="small"
          value={editFormData?.level ? String(editFormData.level) : ""}
          onChange={(event, newValue) => onChangeEditDesgn(event, newValue, "level")}
          options={Array.from({ length: 20 }, (_, index) => `${index + 1}`)}
          sx={{
            backgroundColor: "white",
            width: 200,
            mx: 2, // Equivalent to margin-left and margin-right
            height: 40,
          }}
          renderInput={(params) => <TextField {...params} label="Level" />}
        />
      </TableCell>

      <TableCell align="left">
        <ButtonWrapper>
          <SubmitButton type="submit" disabled = {isUpdating }>{isUpdating? "Updating": "Save"}</SubmitButton>
          <SubmitButton type="button" onClick={() => handleCancelClick(k)}>
            Cancel
          </SubmitButton>
        </ButtonWrapper>
      </TableCell>
    </TableRow>
  );
};

export default DesignationsEditable;
